export default __webpack_public_path__ + "static/media/flag-sardinia.bdbe1e11.svg";